import { ChatAnalyticsDTO } from "@onetutor/shared/dto";
import { useTranslation } from "react-i18next";

interface ChatTopicCardProps {
  chat: ChatAnalyticsDTO;
  topicNumber: number;
}

function ChatTopicCards({ chat, topicNumber }: ChatTopicCardProps) {
  const { t } = useTranslation(["dashboardPage", "header"]);

  return (
    <div key={chat.topic} className="collapse-arrow collapse bg-base-200">
      <input type="checkbox" />
      <h2 className="collapse-title font-medium text-xl">
        {topicNumber + 1}. {t("chatAnalytics.topic")}
        {" - "}
        {chat.topic}
      </h2>
      <ul className="collapse-content flex flex-wrap justify-between">
        {chat.representativeQuestions?.length
          ? chat.representativeQuestions.map((q) => (
              <div
                className="chat chat-start w-full md:w-1/2"
                key={chat.topic + q}
              >
                <div className="chat-bubble chat-bubble-primary w-full">
                  {q}
                </div>
              </div>
            ))
          : "No representative questions available"}
      </ul>
    </div>
  );
}

export default ChatTopicCards;
